import React from 'react'

import { extractFields } from '../../../../../../utils/form/extractFields'
import MConfigurableForm, { FormConfiguration, FormField, FormFieldType } from '../m_configurable_form'

const MHospitalityForm = ({ data }) => {
  const formType = data.form_definition[0].identifier
  const fields = extractFields(data.form_definition[0].form_field)

  const personalFields: Array<FormField> = []
  const addressFields = []
  const helpFields = []
  let sectionIndex = 0
  const firstAddressField = 'street'
  const firstHelpField = 'interest'

  const convertField = (field: any): FormField => {
    let type: FormFieldType = 'string'
    let fullSize = false
    let options: Array<string> | undefined = undefined
    let hint: string

    switch (field.identifier) {
      case 'mail':
      case 'email':
        type = 'email'
        break
      case 'phone':
        type = 'phone'
        break
      case 'postCode':
        type = 'postCode'
        break
      case 'privacy':
        type = 'privacy'
        break
      case 'message':
        fullSize = true
        type = 'message'
        break
      case 'amount':
        type = 'number'
        break
      case 'logename':
        hint = 'Eine Integration des Logos ist leider nicht möglich'
        break
      case 'ordernumber':
        hint = 'Bei Rückfragen zu einer vorhandenen Buchung bitte angeben'
        break
      case 'type':
        type = 'dropdown'
        options = ['Privat', 'Geschäftlich']
        break
      case 'seattype':
        type = 'dropdown'
        options = ['Business Seat', 'Loge']
        break
      case 'interest':
        type = 'dropdown'
        options = [
          'Männer-Nationalmannschaft',
          'Frauen-Nationalmannschaft',
          'DFB-Pokalfinale Männer in Berlin',
          'DFB-Pokalfinale Frauen in Köln',
          'Google Pixel Supercup der Frauen',
          'U21-Männer-Nationalmannschaft',
          'Sonstige Anfrage',
        ]
    }

    return {
      required: field.required,
      identifier: field.identifier,
      label: field.label,
      type: type,
      fullSize,
      options,
      hint,
    }
  }

  function chunkArray(arr: Array<FormField>, size: number): Array<Array<FormField>> {
    const result: Array<Array<FormField>> = []
    let tempArray: Array<FormField> = []

    for (const field of arr) {
      if (field.fullSize) {
        if (tempArray.length) {
          result.push(tempArray)
        }
        result.push([field])
        tempArray = []
      } else {
        tempArray.push(field)
        if (tempArray.length === size) {
          result.push(tempArray)
          tempArray = []
        }
      }
    }

    if (tempArray.length) {
      result.push(tempArray)
    }
    return result
  }

  for (const field of Object.keys(fields)) {
    if (sectionIndex === 0) {
      if (field !== firstAddressField) {
        personalFields.push(convertField(fields[field]))
      } else {
        sectionIndex++
      }
    }

    if (sectionIndex === 1) {
      if (field !== firstHelpField) {
        addressFields.push(convertField(fields[field]))
      } else {
        sectionIndex++
      }
    }

    if (sectionIndex === 2) {
      helpFields.push(convertField(fields[field]))
    }
  }

  const formConfig: FormConfiguration = {
    formType,
    captcha: true,
    buttonLabel: 'Anfrage senden',
    headline: data.headline,
    identifier: data.form_recipient[0].identifier,
    persist: true,
    postUrl: process.env.FORM_API_URL,
    text: data.text,
    sections: [
      {
        title: 'Angaben zur Person',
        fields: chunkArray(personalFields, 2),
      },
      {
        title: 'Rechnungsanschrift/Lieferadresse',
        fields: chunkArray(addressFields, 3),
      },
      {
        title: 'Wie können wir Ihnen weiterhelfen?',
        fields: chunkArray(helpFields, 2),
      },
    ],
  }

  return <MConfigurableForm config={formConfig} />
}

export default MHospitalityForm
